import { Component } from '@angular/core';
import { NavController, LoadingController } from 'ionic-angular';

import { ApiService } from '../../app/services/api.service';
import { GridPage } from '../grid/grid';

@Component({
    selector: 'page-error',
    templateUrl: 'error.html',
    providers: [ApiService]
})


export class ErrorPage {

    constructor(public navCtrl: NavController,
        private _apiService: ApiService,
        private loadingCtrl: LoadingController) {

    }
}



// WEBPACK FOOTER //
// ./src/pages/error/error.ts